import React from "react";
import { Box, Stack } from "@mui/material";
import SectionFrame from "../SectionFrame";
import { EditableButton, EditableText } from "../InlineEditable";
import EditableImage from "../EditableImage";
import { resolveLandingAssetUrl } from "../../../../utils/landingAssets";

export default function SpotlightSection({ form, active, device, productsEnabled, onSelect, onCommit, onCommitMany, onUploadImage, onRemoveImage, disabled }) {
  const isMobile = device === "mobile";
  const spotlight = form.catalog.spotlight || {};
  const primary = spotlight.primaryColor || form.theme.primaryColor || "#F35A3A";
  const secondary = spotlight.secondaryColor || form.theme.secondaryColor || "#19242F";
  const background = resolveLandingAssetUrl(spotlight.backgroundImageUrl);
  const enabled = productsEnabled && form.sections.showProducts !== false && form.sections.showSpotlight !== false && spotlight.enabled === true;

  const toggle = (next) => {
    if (!productsEnabled) return;
    if (onCommitMany) {
      onCommitMany({
        "sections.showProducts": true,
        "sections.showSpotlight": next,
        "catalog.spotlight.enabled": next,
      });
      return;
    }
    onCommit("catalog.spotlight.enabled", next);
  };

  return (
    <SectionFrame id="spotlight" label="Spotlight" active={active} enabled={enabled} onSelect={onSelect} onToggle={toggle}>
      <Box
        sx={{
          position: "relative",
          overflow: "hidden",
          px: isMobile ? 2.2 : 6,
          py: isMobile ? 5 : 6,
          background: background
            ? `linear-gradient(90deg, ${secondary}F2, ${primary}D9), url(${background}) center/cover`
            : `linear-gradient(100deg, ${secondary} 0%, ${primary} 100%)`,
        }}
      >
        <Box aria-hidden sx={{ position: "absolute", width: isMobile ? 230 : 360, height: isMobile ? 230 : 360, borderRadius: "50%", left: 0, top: "50%", transform: "translate(-48%,-50%)", background: "radial-gradient(circle, rgba(255,255,255,.18), transparent 68%)" }} />
        <Box aria-hidden sx={{ position: "absolute", width: isMobile ? 180 : 300, height: isMobile ? 180 : 300, borderRadius: "50%", right: 0, top: "50%", transform: "translate(45%,-50%)", background: "radial-gradient(circle, rgba(0,0,0,.18), transparent 70%)" }} />
        <Box sx={{ position: "relative", zIndex: 1, maxWidth: 1180, mx: "auto", display: "flex", alignItems: "center", justifyContent: "space-between", flexDirection: isMobile ? "column" : "row", gap: isMobile ? 3 : 5 }}>
          <Box sx={{ flexShrink: 0, width: isMobile ? 230 : 300, bgcolor: "#fff", borderRadius: 2, p: 1.2, boxShadow: "0 10px 30px rgba(0,0,0,.28)" }}>
            <EditableImage
              value={spotlight.logoUrl}
              label="Logo destacado"
              height={isMobile ? 84 : 96}
              disabled={disabled}
              onUpload={(file) => onUploadImage("catalog.spotlight.logoUrl", file, { sectionKey: "spotlight", assetKey: "logo" })}
              onRemove={() => onRemoveImage("catalog.spotlight.logoUrl")}
              sx={{ minHeight: isMobile ? 84 : 96, bgcolor: "#fff", backgroundSize: "contain", backgroundRepeat: "no-repeat", borderColor: "rgba(25,36,47,.15)" }}
            />
          </Box>
          {!isMobile ? <Box sx={{ width: "1px", alignSelf: "stretch", bgcolor: "rgba(255,255,255,.25)" }} /> : null}
          <Box sx={{ flex: 1, color: "#fff", textAlign: isMobile ? "center" : "left" }}>
            <EditableText value={spotlight.eyebrow} fallback="Marca destacada" disabled={disabled} onSave={(value) => onCommit("catalog.spotlight.eyebrow", value)} sx={{ color: "rgba(255,255,255,.72)", textTransform: "uppercase", letterSpacing: 1.3, fontWeight: 850, fontSize: 12 }} />
            <Box sx={{ mt: 0.5 }}><EditableText value={spotlight.title} fallback="Una propuesta especial" disabled={disabled} multiline onSave={(value) => onCommit("catalog.spotlight.title", value)} sx={{ color: "#fff", fontWeight: 950, fontSize: isMobile ? 34 : 46, lineHeight: 1.05, textShadow: "0 3px 14px rgba(0,0,0,.35)" }} /></Box>
            <Box sx={{ mt: 1 }}><EditableText value={spotlight.description} fallback="Presentá una marca, campaña o categoría que quieras destacar." disabled={disabled} multiline onSave={(value) => onCommit("catalog.spotlight.description", value)} sx={{ color: "rgba(255,255,255,.76)", lineHeight: 1.7, maxWidth: 540 }} /></Box>
          </Box>
          <EditableButton value={spotlight.ctaLabel} fallback="Ver propuesta" disabled={disabled} onSave={(value) => onCommit("catalog.spotlight.ctaLabel", value)} sx={{ flexShrink: 0, minWidth: isMobile ? "100%" : 180, bgcolor: "#fff", color: primary, borderRadius: 2, px: 3, py: 1.15, fontWeight: 950 }} />
        </Box>
        <Box sx={{ position: "absolute", left: 12, bottom: 12, zIndex: 10, width: isMobile ? 150 : 190 }}>
          <EditableImage
            value={spotlight.backgroundImageUrl}
            label="Fondo spotlight"
            height={74}
            disabled={disabled}
            onUpload={(file) => onUploadImage("catalog.spotlight.backgroundImageUrl", file, { sectionKey: "spotlight", assetKey: "background" })}
            onRemove={() => onRemoveImage("catalog.spotlight.backgroundImageUrl")}
            sx={{ bgcolor: "rgba(255,255,255,.12)", borderColor: "rgba(255,255,255,.4)" }}
          />
        </Box>
      </Box>
    </SectionFrame>
  );
}
